import React from "react";
import { Card, CardBody } from "reactstrap";
import { ArrowRightCircle } from "react-feather";
import { Link } from "react-router-dom";

import News from "~/assets/images/dashboard/news.png";

import rawHtml   from 'html-react-parser';
import useResize from "~/hooks/useResize";
import validator from  'validator';


const AnnouncementCard = ({item, breakpoint})=> {

  const [ width ] = useResize();

  return (
    <div>
      <Link
        to={{pathname: item.redirectUrl}}
        target={validator.isURL(item.redirectUrl?.toString() || '') ? '_blank' : '_self' }
        style={{pointerEvents: !item.redirectUrl && 'none'}}
      >
        <Card className="announcement-card">
          <CardBody>
            <div className="card-body-row">
              <div className="icon">
                <img src={item.icon ? item.icon : News} style={{maxWidth: width < breakpoint ? 24 : 50, transform: `rotate(${item.icon ? 0 : -30}deg)` }} /> :
              </div>
              <div className="text">
                <h5 className="f-16"> <strong>{item.title}</strong> </h5>
                { rawHtml(item.description || '') }
              </div>

              { validator.isURL(item.redirectUrl?.toString() || '') &&
                <div className="arrow"> <ArrowRightCircle color="black" /> </div>
              }

            </div>
          </CardBody>
        </Card>
      </Link>
    </div>
  );
};

export default AnnouncementCard;
